import React, { useState, useEffect } from "react";
import "./Bill.css";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { storage, auth, db } from "./firebase";
import Pdf from "react-to-pdf";

import { TiTick } from "react-icons/ti";
import TaskerDetails from "./TaskerDetails";
function Bill() {
  const { booId } = useParams();
  const ref = React.createRef();

  const [serviceOrder, setServiceOrder] = useState([]);
  const [getTas, setGetTas] = useState("");
  const [getHours, setGetHours] = useState([]);

  const [customer, setCustomerData] = useState("");

  const history = useHistory();
  function GetUserUid() {
    const [uid, setUid] = useState(null);
    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          console.log("YESS", user);
          setUid(user.uid);
        }
      });
    }, []);
    return uid;
  }
  const uid = GetUserUid();

  function GetCurrentUser() {
    const [user, setUser] = useState(null);
    const [roomDetails, setRoomDetails] = useState([]);

    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          db.collection("customers").doc(user.uid).get();
        } else {
          setUser(null);
        }
      });
    }, []);
    return user;
  }
  const user = GetCurrentUser();
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .onSnapshot((snapshot) => setCustomerData(snapshot.data()));
    }
  });
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .collection("serviceOrders")
        .doc(booId)
        .onSnapshot((snapshot) => setServiceOrder(snapshot.data()));
    }
  }, [uid]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .collection("ServiceRequests")
        .doc(serviceOrder?.requestId)
        .onSnapshot((snapshot) => setGetHours(snapshot.data()));
    }
  }, [serviceOrder?.tasId]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .onSnapshot((snapshot) => setGetTas(snapshot.data()));
    }
  });
  return (
    <div className="bill" ref={ref}>
      <div className="bill__container">
        <div className="bill__containerTop">
          <h1>Fast Fix</h1>
        </div>
        <div className="bill__containerMiddle">
          <h2>Payment Receipt</h2>
        </div>
        <h3>
          <TiTick /> Paid ₹ {getHours?.totalAmount}
        </h3>
        <p style={{ marginLeft: "30px" }}>August 26, 2022. 7:59 PM</p>
        <div className="bill__containerBottom">
          <div className="bill__containerBottomElements">
            <h3>Transaction ID</h3>

            <p style={{ marginTop: "20px" }}>{booId}</p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>From</h3>
            <p style={{ marginTop: "-20px", marginLeft: "10px" }}>
              Anand AS . cus@gmail.com
            </p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>To</h3>
            <p style={{ marginTop: "-20px" }}>Anand AS . cus@gmail.com</p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>Service</h3>
            <p style={{ marginTop: "-20px" }}>Baby Bathing</p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>Tasker Rate</h3>
            <p style={{ marginTop: "-20px" }}>₹  {serviceOrder?.price}/hour</p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>Hours Worked</h3>
            <p style={{ marginTop: "-20px" }}>{getHours?.hours}</p>
          </div>
          <div className="bill__containerBottomElements">
            <h3 style={{ marginTop: "-20px" }}>Tasker Total</h3>
            <strong style={{ marginTop: "-20px", color: "red" }}>₹ {getHours?.totalAmount}</strong>
          </div>
        </div>
      </div>
      <Pdf targetRef={ref} filename="post.pdf">
        {({ toPdf }) => <button onClick={toPdf}>Capture as PDF</button>}
      </Pdf>
    </div>
  );
}

export default Bill;
